module.exports = __webpack_public_path__ + "media/images/lb/273-c47df724d9e6ddc1fde43281f1900636.svg";